__turbopack_context__.v({
  "className": "fira_code_1289b970-module__t6Hyxa__className",
});
